let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2mrcn")).then(() => parcelRequire('4Mf12'));